import { Alert, Button, Space } from 'antd'
import authService from '../../authService'

export default function FirstLoginSessionNotice({ reason, recovery }) {
  const refreshing = recovery?.status === 'refreshing'
  const reauthenticate = recovery?.status === 'reauthenticate'
  const failed = recovery?.status === 'failed'
  const support = recovery?.attempted && !refreshing && !reauthenticate && !failed
  const message = refreshing ? 'Actualizando tu sesión…'
    : reauthenticate ? 'Tu sesión venció o fue revocada. Volvé a iniciar sesión para continuar.'
    : failed ? 'No pudimos actualizar tu sesión. Volvé a iniciar sesión; si el problema persiste, contactá a soporte.'
    : support || reason === 'inactive' ? 'No pudimos completar la configuración de tu cuenta. Contactá a soporte.'
    : 'Necesitamos actualizar tu sesión para configurar el comercio.'
  return <section style={{ maxWidth: 600, margin: '15vh auto', padding: 24 }} aria-label="Estado de configuración de la cuenta">
    <Alert type="warning" showIcon message={message} description={refreshing
      ? 'Estamos actualizando tu sesión. Esperá un momento para continuar con la configuración de tu negocio.'
      : 'Si no podés continuar después de iniciar sesión nuevamente, contactá a soporte para revisar el acceso a tu comercio.'} />
    <Space wrap style={{ marginTop: 20 }}>
      {!recovery?.attempted && reason !== 'inactive' && <Button onClick={() => authService.refreshMerchantSession()}>Actualizar sesión</Button>}
      {refreshing && <Button loading disabled aria-label="Actualizando sesión">Actualizando sesión</Button>}
      <Button onClick={() => authService.logout({ reload: false })}>Volver al login</Button>
    </Space>
  </section>
}
